import React from "react";
import { motion } from "framer-motion";
import "../styles/About.css";

const About = () => {
  return (
    <motion.section
      id="about"
      className="about"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <section id="about" className="about">
        <h2>About Me</h2>
        <h3>My Introduction</h3>
        <p>
          Web developer, with extensive knowledge and years of experience,
          working in web...
        </p>
      </section>
    </motion.section>
  );
};

export default About;
